import React from 'react';
import PropTypes from 'prop-types';
import { STORECATEGORYPAGE } from '../../events/screens';
import * as LogClevertapEvent from 'clevertap/LogEvent';
import { Svg } from 'app/components/common';

function StoreFilters(props) {
  const {
    filters, onSelectFilter, selectedFilter,
  } = props;

  return (
    <div className="pt-3 d-flex horizontal-scroll-list">
      {
        filters?.map((item) => {
          const isFilterSelected = (item.filterId === selectedFilter);
          return (
            <button
            key={item.filterId}
            className={`${
              (isFilterSelected)
                ? 'quickFilter_btn--selected'
                : ''
            } d-flex px-4 py-2 mx-2 quickFilter_btn border-light`}
            onClick={() => {
              onSelectFilter((isFilterSelected) ? '' : item.filterId);
              LogClevertapEvent.shopFilterClicked(STORECATEGORYPAGE, item.name);
            }}
          >
            {item.filterDisplayName}
            {
              (isFilterSelected) && (
                <span className="pl-2 py-0 border-0">
                  <Svg
                    svg='circleClose'
                    circleFill="#b8238e"
                    pathFill="#fff"
                    width="16px"
                    circleStroke={4}
                  />
                </span>
              )
            }
          </button>
          )
        })
      }
    </div>
  );
}

StoreFilters.propTypes = {
  selectedFilter: PropTypes.string,
  filters: PropTypes.arrayOf(
    PropTypes.shape({})
  ).isRequired,
  onSelectFilter: PropTypes.func,
};

StoreFilters.defaultProps = {
  onSelectFilter: () => {},
  selectedFilter: '',
};

export default StoreFilters;
